module.exports = __webpack_public_path__ + "img/undTooth14.3c2b0179.png";